module.exports = __webpack_public_path__ + "static/media/17_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.ef5495ac.jpg";